let beamsClient;

try {
    beamsClient = new PusherPushNotifications.Client({
        instanceId: process.env.MIX_BEAMS_INSTANCE_ID
    });
    console.info('Beams supported');
} catch (err) {
    if (err.message.includes("Pusher Beams does not support this browser version")) {
        beamsClient = null;
        console.error('Pusher Beams does not support this browser version');
    } else {
        throw err;
    }
}


export default beamsClient;